export type BookingActionBannerTone = 'pending' | 'confirmed';

export type BookingActionBanner = {
  copy: string;
  tone: BookingActionBannerTone;
};

export function bookingActionBanner(type?: string | null): BookingActionBanner | null {
  if (type === 'booking_requested') {
    return {
      copy: 'Request sent — the stylist will confirm it shortly.',
      tone: 'pending',
    };
  }
  if (type === 'booking_confirmed') {
    return {
      copy: 'Booking confirmed — check your messages for details.',
      tone: 'confirmed',
    };
  }
  return null;
}
